export enum GenreFamily {
    BassMusic = 'bass_music',
    DanceMusic = 'dance_music',
    Electronic = 'electronic',
    HiphopRnB = 'hiphop',
    International = 'international',
    Live = 'live',
    PopEDM = 'pop_edm',
    Soundtrack = 'soundtrack',
    BluesFolk = 'blues_folk',
    Latin = 'latin',
    RockMetal = 'rock_metal',
    SoulJazz = 'soul_jazz',
}
